'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

//TODO: we need to have this button on the home page and the POP page

const QuizTabButton = (): JSX.Element => {
  const t = useTranslations();
  return (
    <Link
      className="fixed bottom-36 right-0 z-200 inline-block origin-bottom-right text-nowrap rounded-t-lg bg-slate-100 px-6 py-3 text-slate-800 md:bottom-24"
      href="/ring-assessment"
      style={{ transform: 'rotate(-90deg) translateX(100%)' }}
    >
      {t('d2c_quiz_take_quiz')}
    </Link>
  );
};

export default QuizTabButton;
